import React, { useState, useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import './desktop-product-list-filter-style.scss';
import Typography from '@src/componentsNew/Typography/Typography';

import useIsComDomain from '@src/hooks/useIsComDomain';

import { parsingBrandCategoryData } from '@src/utils';
import { brand_brand_categories_edges } from '@src/components/ProductPage/BrandPage/__generated__/brand';
import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { DESKTOP_PRODUCTS_FILTER_OPTIONS, COM_DESKTOP_PRODUCTS_FILTER_OPTIONS } from '@src/utils/constants';
import { StockAvailability } from '__generated__/globalTypes';

interface IProps {
  initialVariables?: productsVariables;
  variables: productsVariables;
  setVariables: any;
  brandCategories?: brand_brand_categories_edges[];
}

const DesktopProductListFilter: React.FC<IProps> = ({
  initialVariables,
  variables,
  setVariables,
  brandCategories,
}: IProps) => {
  const isComDomain = useIsComDomain();
  const parsedBrandCategories = parsingBrandCategoryData(brandCategories);

  const [selectedVariables, setSelectedVariables] = useState(variables);
  const [selectedParent, setSelectedParent] = useState(null); // 선택된 중분류 카테고리 id
  const [selectedChild, setSelectedChild] = useState(null); // 선택된 소분류 카테고리 id

  const handleClickRadio = (groupName, value) => {
    setSelectedVariables((prev) => ({
      ...prev,
      [groupName]: value,
    }));

    setVariables((prev) => {
      const updatedVariables = { ...prev };

      if (groupName === 'isMgs') {
        if (value === '') {
          delete updatedVariables[groupName];
        } else {
          updatedVariables[groupName] = value === 'true';
        }
      } else {
        updatedVariables[groupName] = value ? value : null;
      }

      return updatedVariables;
    });
  };

  const handleParentClick = (parentId) => {
    if (selectedParent === parentId) {
      setSelectedParent(null);

      setVariables((prev) => {
        const updatedVariables = { ...prev };
        delete updatedVariables['categories'];

        return updatedVariables;
      });
    } else {
      setSelectedParent(parentId);
      setSelectedChild(null);

      setVariables((prev) => ({
        ...prev,
        categories: parentId,
      }));
    }
  };

  const handleChildClick = (parentId, childId) => {
    setSelectedParent(parentId);
    setSelectedChild(childId);

    setVariables((prev) => ({
      ...prev,
      categories: childId,
    }));
  };

  const handleClickClear = () => {
    const getUpdatedVariables = (prev) => {
      const updatedVariables = { ...prev };

      if ('isMgs' in updatedVariables) {
        delete updatedVariables['isMgs'];
      }

      updatedVariables['stockAvailability'] = StockAvailability.IN_STOCK;

      return updatedVariables;
    };

    setSelectedVariables(getUpdatedVariables);
    setVariables(getUpdatedVariables);
  };

  return Object.keys(variables).length ? (
    <div id="desktop-product-list-filter">
      <div className="filter-header">
        <Typography variant="subtitle1" component="span" style={{ color: '#090A0FDE' }}>
          Filters
        </Typography>
        <Typography
          cName="filter-clear"
          variant="subtitle2"
          component="span"
          onClick={handleClickClear}
          style={{ color: '#9E9E9E' }}
        >
          Clear
        </Typography>
      </div>

      <div className="filter-body">
        {(isComDomain ? COM_DESKTOP_PRODUCTS_FILTER_OPTIONS : DESKTOP_PRODUCTS_FILTER_OPTIONS).map((option, idx) => (
          <div key={idx} className="filter-item">
            <Typography cName="filter-option-name" variant="subtitle2" component="span" style={{ color: '#666666' }}>
              {option.title}
            </Typography>

            <RadioGroup
              className="radio-filter-wrapper"
              name={option.name}
              value={selectedVariables ? String(selectedVariables[option.name]) : ''}
              onChange={(event) => handleClickRadio(option.name, event.target.value)}
            >
              {option.options.map((item, idx) => (
                <FormControlLabel
                  key={idx}
                  className="custom-radio-option-item"
                  label={item.title}
                  value={item.value}
                  control={
                    <Radio
                      sx={{
                        color: '#21242A7A',
                        '&.Mui-checked': {
                          color: '#FF3399',
                        },
                      }}
                    />
                  }
                  checked={
                    (option.name === 'isMgs' &&
                      (selectedVariables.isMgs === true
                        ? item.value === true
                        : selectedVariables.isMgs === undefined && item.value === '')) ||
                    selectedVariables[option.name] === item.value.toString()
                  }
                />
              ))}
            </RadioGroup>
          </div>
        ))}

        {parsedBrandCategories?.length ? (
          <div className="filter-item">
            <Typography cName="filter-option-name" variant="subtitle2" component="span" style={{ color: '#666666' }}>
              Category
            </Typography>

            <div className="category-filter-wrapper">
              {parsedBrandCategories?.map((parentCategory) => (
                <div key={parentCategory.id} className="category-filter-option">
                  <div className="product-count-wrapper parent" onClick={() => handleParentClick(parentCategory.id)}>
                    <Typography
                      cName={`category-filter-caption1 ${selectedParent === parentCategory.id ? 'selected' : ''}`}
                      variant="caption"
                      component="span"
                    >
                      {parentCategory.name}
                    </Typography>

                    {/* <Typography
                            cName="count-text"
                            variant="caption"
                            component="span">
                            {parentCategory.totalCount}
                          </Typography> */}
                  </div>

                  {selectedParent === parentCategory.id && (
                    <ul className="child-category-wrapper">
                      {parentCategory.child.map((child) => (
                        <li key={child.id} className="product-count-wrapper child">
                          <Typography
                            onClick={() => handleChildClick(parentCategory.id, child.id)}
                            cName={`category-filter-caption2 ${selectedChild === child.id ? 'selected' : ''}`}
                            variant="caption"
                            component="span"
                          >
                            {child.name}
                          </Typography>

                          {/* <Typography
                                      cName="count-text"
                                      variant="caption"
                                      component="span">
                                      {child.totalCount}
                                    </Typography> */}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default DesktopProductListFilter;
